import { useApiClient } from "@/infrastructure/rest";
import { DossierVosOproepen } from "@/shared/types";
import { useQuery } from "@tanstack/react-query";
import { VOS_OPROEPEN_QUERY_KEY } from "../constants";
import { DossierVosOproep } from "../domain";

export function useGetDossierVosOproepen() {
    const apiClient = useApiClient();

    return useQuery({
        queryKey: [VOS_OPROEPEN_QUERY_KEY],
        queryFn: async () => {
            const data = await apiClient.get<DossierVosOproepen[]>(`/debug/vosoproepen`);
            return data?.map((dto) => DossierVosOproep.fromDto(dto))?.sort(DossierVosOproep.sort) ?? [];
        },
    });
}
